/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadTargetAttachment$Params {
  targetID?: number;
      body?: {
'file'?: Blob;
}
}

export function UploadTargetAttachment(http: HttpClient, rootUrl: string, params?: UploadTargetAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UploadTargetAttachment.PATH, 'post');
  if (params) {
    rb.query('targetID', params.targetID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UploadTargetAttachment.PATH = '/api/Supervisor/UploadTargetAttachment';
